import React from "react";
import { TextField, Tooltip } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopTimePicker } from "@mui/x-date-pickers/DesktopTimePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import {
  TIME_FILTERS_SAME_DATE_TOOLTIP,
  timeFiltersSameDateTooltipProps,
} from "../../common/timeFiltersSameDateTooltip";
import { useNavigate } from "react-router-dom";

export const EndTimeDropDownAILink = ({
  userFilters,
  setUserFilters,
  showUserDropDown,
  timeFiltersDisabledAILink,
}: {
  userFilters: any;
  setUserFilters: Dispatcher<any>;
  showUserDropDown: boolean;
  timeFiltersDisabledAILink: boolean;
}) => {
  const navigate = useNavigate();

  const sx = showUserDropDown ? { width: 132 } : { width: 135 };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Tooltip
        title={TIME_FILTERS_SAME_DATE_TOOLTIP}
        disableHoverListener={!timeFiltersDisabledAILink}
        disableFocusListener={!timeFiltersDisabledAILink}
        disableTouchListener={!timeFiltersDisabledAILink}
        {...timeFiltersSameDateTooltipProps}
      >
        <span style={{ display: "inline-block" }}>
          <DesktopTimePicker
            label="End Time"
            value={userFilters.end_time ? userFilters.end_time : null}
            onChange={(newValue) => {
              setUserFilters((previousState: any) => {
                return { ...previousState, end_time: newValue };
              });
            }}
            disabled={timeFiltersDisabledAILink}
            renderInput={(params) => (
              <TextField {...params} autoComplete="off" sx={sx} />
            )}
          />
        </span>
      </Tooltip>
    </LocalizationProvider>
  );
};
